/**
 * An object used to get page information from the server
 * Created by Maga on 04.06.2018.
 */

export class PageDTO {
  // The number of elements in the page
  size = 30;
  // The total number of elements
  totalElements = 0;
  // The total number of pages
  totalPages = 0;
  // The current page number
  pageNumber = 0;
  filter: any;
  sorting: any;
  advancedSearch: any;
}



// WEBPACK FOOTER //
// ./src/app/common/dtos/PageDTO.ts